import { render, staticRenderFns } from "./quesTreeStep.vue?vue&type=template&id=64b988f6&scoped=true"
import script from "./quesTreeStep.vue?vue&type=script&lang=js"
export * from "./quesTreeStep.vue?vue&type=script&lang=js"
import style0 from "./quesTreeStep.vue?vue&type=style&index=0&id=64b988f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b988f6",
  null
  
)

export default component.exports